var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgUsFlag = function SvgUsFlag(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_117)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H14.4V11.2H0V0Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 0V1.6H33.6V0H14.4ZM14.4 3.2V4.8H33.6V3.2H14.4ZM14.4 6.4V8H33.6V6.4H14.4ZM14.4 9.6V11.2H33.6V9.6H14.4ZM0 12.8V14.4H33.6V12.8H0ZM0 16V17.6H33.6V16H0ZM0 19.2V20.8H33.6V19.2H0ZM0 22.4V24H33.6V22.4H0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 1.6V3.2H3.2V1.6H1.6ZM4.8 1.6V3.2H6.4V1.6H4.8ZM8 1.6V3.2H9.6V1.6H8ZM11.2 1.6V3.2H12.8V1.6H11.2ZM9.6 3.2V4.8H11.2V3.2H9.6ZM6.4 3.2V4.8H8V3.2H6.4ZM3.2 3.2V4.8H4.8V3.2H3.2ZM1.6 4.8V6.4H3.2V4.8H1.6ZM4.8 4.8V6.4H6.4V4.8H4.8ZM8 4.8V6.4H9.6V4.8H8ZM11.2 4.8V6.4H12.8V4.8H11.2ZM1.6 8V9.6H3.2V8H1.6ZM4.8 8V9.6H6.4V8H4.8ZM8 8V9.6H9.6V8H8ZM11.2 8V9.6H12.8V8H11.2ZM9.6 6.4V8H11.2V6.4H9.6ZM6.4 6.4V8H8V6.4H6.4ZM3.2 6.4V8H4.8V6.4H3.2Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgUsFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/us-flag.db5939aa46c9193ecc070b47bf1a78a0.svg";